import { IfcCalculatorConfigModel } from 'models';

export class IfcPaymentStateModel {
    public deposit: number = 0;
    public depositPercentage: number = 0;
    public months: number = 0;
    public monthlyPayment: number = 0;

    public minDeposit: number = 0;
    public maxDeposit: number = 0;
    public minMonths: number = 0;
    public maxMonths: number = 0;

    public ifcConfig: IfcCalculatorConfigModel;
}